<template>
  <div>
    <div class="page-title">发票信息审核</div>
    <page-search
      :layout="['customName', 't_agent_info_agent_name']"
      @search="search"
    ></page-search>
    <pageTable
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :pageIndex="page"
      :pageSize="pageSize"
      :page="page"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>

<script>
import Vue from 'vue'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import { getReviewList } from '@/api/invoice'
import { formatText } from '@/utils/common'
export default {
  name: 'examine',
  components: {
    pageTable, pageSearch
  },
  mixins: [pageTableMixin],
  data() {
    return {
      corpTypeKey: '', // 1 工业 2 服务商
      companyName: '', // 客户名称
      t_agent_info_agent_name: '', // 渠道
      col: [
        { field: 'operate', title: '操作', width: 90, componentName: 'examineOpe' },
        { field: 'status', title: '状态', width: 90,
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            return formatText(rowData.is_audit, ['<span class="red">已驳回</span>', '<span>待审核</span>', '<span class="green">已通过</span>'])
          }
        },
        { field: 'company_id', title: '客户ID', width: 90, showTitle: true, overflowTitle: true },
        { field: 't_agent_info_agent_name', title: '渠道', width: 160, isResize: true, showTitle: true, overflowTitle: true },
        { field: 'company_name', title: '客户名称', width: 220, isResize: true, showTitle: true, overflowTitle: true },
        { field: 'company_title', title: '发票抬头', width: 220, isResize: true, showTitle: true, overflowTitle: true },
        { field: 'invoice_type', title: '发票类型', width: 120, isResize: true, showTitle: true,
          formatter: function(rowData) {
            const type = ['', '增值税普通发票', '增值税专用发票']
            return type[rowData.invoice_type]
          },
          overflowTitle: true
        },
        { field: 'tax_type', title: '纳税类型', width: 100, isResize: true,
          formatter: function(rowData) {
            return formatText(rowData.tax_type, ['', '一般纳税人', '小规模纳税人'])
          },
          overflowTitle: true
        },
        { field: 'bank_name', title: '开户行', width: 220, showTitle: true, overflowTitle: true },
        { field: 'phone', title: '电话', width: 110, showTitle: true, overflowTitle: true },
        { field: 'tax_no', title: '税号', width: 200, showTitle: true, overflowTitle: true },
        { field: 'bank_no', title: '帐号', width: 160, isResize: true, showTitle: true, overflowTitle: true },
        { field: 'address', title: '地址', width: 260, isResize: true, showTitle: true, overflowTitle: true }
        // 发票管理-删除字段
        // { field: 'validity', title: '有效期', width: 160, isResize: true, showTitle: true },
        // { field: 'memo', title: '备注信息', width: 260, showTitle: true }
      ]
    }
  },
  methods: {
    initPage() {
      this.corpTypeKey = this.$route.name === 'examinei' ? '1' : '2'
      this.companyName = ''
      this.t_agent_info_agent_name = ''
    },
    search(query) {
      this.companyName = query.customName || ''
      this.t_agent_info_agent_name = query.t_agent_info_agent_name || ''
      this.page = 1
      this.getData()
    },
    // 获取表格
    getData() {
      this.tableLoading = true
      getReviewList({
        current_page: this.page,
        rp: this.pageSize,
        corp_type_key: this.corpTypeKey,
        'company_name': this.companyName,
        t_agent_info_agent_name: this.t_agent_info_agent_name
      }).then(res => {
        this.tableLoading = false
        if (res.code === 0) {
          this.tableData = res.result.data
          this.total = res.result.count
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
          this.tableData = []
          this.total = 0
        }
      })
    }
  }
}

// 自定义列组件
Vue.component('examineOpe', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    examine() {
      this.$router.push({
        name: 'examineDetail', params: { id: this.rowData.invoice_id, type: this.rowData.company_type }
      })
    },
    detail(rowData) {
      this.$router.push({
        name: 'invoiceInfo', params: { id: this.rowData.invoice_id, type: this.rowData.company_type }
      })
    }
  },
  render: function(h) {
    if (Number(this.rowData.is_audit) === 1) {
      // 开发票
      return h('div', {
        class: 'link-btn',
        on: {
          click: this.examine
        }
      }, '审核')
    } else {
      // 查看发票
      return h('div', {
        class: 'link-btn',
        on: {
          click: this.detail
        }
      }, '查看')
    }
  }
})
</script>
